import { addMessages } from '@hana/i18n';

// Khoá chuỗi của Công nợ › Hàng chờ khớp tiền (Match.tsx). Dữ liệu mẫu và mã nghiệp vụ không dịch.
addMessages('vi', {
  'mt.noWrite': 'Chưa mở ghi ở bản này', 'mt.pasteAria': 'Dán dòng sao kê',
  'mt.pasteIn': 'Dán một dòng sao kê bất kỳ (VCB/TCB, email báo có, tin nhắn ngân hàng)…', 'mt.pasteInAria': 'Dán một dòng sao kê',
  'mt.read': 'Đọc & gợi ý',
  'mt.kToday': 'Dòng sao kê hôm nay', 'mt.kAuto': 'Tự khớp được', 'mt.kPick': 'Cần người chọn', 'mt.unitRow': 'dòng',
  'mt.hDate': 'Ngày · tài khoản', 'mt.hAmt': 'Số tiền', 'mt.hMemo': 'Nội dung chuyển khoản · người chuyển', 'mt.hMatch': 'Khớp với debit', 'mt.hStatus': 'Trạng thái',
  'mt.aria': 'Hàng chờ khớp tiền', 'mt.adv': 'Trả trước · chưa có debit', 'mt.choose': 'Chọn debit…',
  'mt.listAria': 'Chọn debit để khớp', 'mt.popHd': 'Debit mở của {p}', 'mt.left': 'còn {v}',
  'mt.advBtn': 'Ghi nhận trả trước (chưa có debit)', 'mt.confirm': 'Xác nhận khớp', 'mt.done': 'Đã cấn',
  'mt.toastOne': 'Đã cấn {a} tr vào {to}', 'mt.toAdv': 'trả trước {p}',
  'mt.stmt': 'Sao kê VCB · TCB nhập lúc 08:15 · 22/Oct/2026', 'mt.confirmAll': 'Xác nhận tất cả dòng tự khớp', 'mt.toastAll': 'Đã cấn các dòng tự khớp',
});
addMessages('en', {
  'mt.noWrite': 'Writing is not enabled in this version', 'mt.pasteAria': 'Paste statement line',
  'mt.pasteIn': 'Paste any statement line (VCB/TCB, credit email, bank SMS)…', 'mt.pasteInAria': 'Paste a statement line',
  'mt.read': 'Read & suggest',
  'mt.kToday': 'Statement lines today', 'mt.kAuto': 'Auto-matched', 'mt.kPick': 'Needs a pick', 'mt.unitRow': 'lines',
  'mt.hDate': 'Date · account', 'mt.hAmt': 'Amount', 'mt.hMemo': 'Transfer memo · payer', 'mt.hMatch': 'Match to debit', 'mt.hStatus': 'Status',
  'mt.aria': 'Payment matching queue', 'mt.adv': 'Prepayment · no debit yet', 'mt.choose': 'Pick a debit…',
  'mt.listAria': 'Pick a debit to match', 'mt.popHd': 'Open debits of {p}', 'mt.left': '{v} left',
  'mt.advBtn': 'Record as prepayment (no debit yet)', 'mt.confirm': 'Confirm match', 'mt.done': 'Applied',
  'mt.toastOne': 'Applied {a} m to {to}', 'mt.toAdv': 'prepayment {p}',
  'mt.stmt': 'VCB · TCB statements imported 08:15 · 22/Oct/2026', 'mt.confirmAll': 'Confirm all auto-matched lines', 'mt.toastAll': 'Auto-matched lines applied',
});
